
import styles from './notFound.module.css';
import { HashLink } from 'react-router-hash-link';
export const NotFoundPage = () => {
    return (
        <div className={styles.main} >
            <div className={`${styles.bgDigitalMaze} absolute inset-0`}></div>
              <main className={styles.content}>
       
            <div className={styles.illustrationContainer}>
                <img alt="Illustration of a confused person with the number 404 indicating a page not found error."
                    className="w-full h-auto"
                    src="/404img3.png" />
            </div>
            <div className={styles.textContainer}>
                <p className={`${styles.errorText} font-semibold text-lg mb-2`} style={{  color: '#3B82F6'  }}>Error 404</p>
                <h1 className="text-4xl md:text-5xl font-bold text-gray-800  mb-4">Page Not Found</h1>
                <p className="text-gray-600  mb-8 max-w-md mx-auto md:mx-0">
               The page you&#39;re looking for might have been moved,
                    deleted, or perhaps never existed. Let&#39;s get you back on track.
                </p>
                <div className={styles.buttonContainer}>
                    <a className={styles.button}
                        href="/">
                 <svg  xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" stroke="#FFFFFF" strokeWidth="1.5"/></svg>
                        Go Home
                    </a>
                    
                    <HashLink className={styles.contactSupport}
                        smooth to="/about#contact">
                        Contact Support
                    </HashLink>
                </div>
             
            </div>
       
    </main>
        </div>
    );
};

